import styled from '../../../config/theme'

const Actions = styled.div`
  display: flex;

  > * {
    margin: 0 5px;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`

export {
  Actions,
  ModalContent,
}
